import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  IGroupTutorRateVersion,
  IGroupTutorRateVersionDeleteVerificationData,
  TGroupTutorRateVersionConditionTypes,
  TGroupTutorRateVersionTutorRegistrationDateConditionTypes,
} from '.';
import {
  AdminApiPaths,
  APIDataProvider,
  TApiPaginationResponse,
  TApiResponse,
} from '../../../api';

export type TAdminCreateGroupTutorRateVersion = {
  name: string;
  hideToUser: boolean;
  conditions?: Array<{
    type: TGroupTutorRateVersionConditionTypes;
    logic: TGroupTutorRateVersionTutorRegistrationDateConditionTypes;
    date: string;
  }>;
};

export type TAdminGetGroupTutorRateVersions = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  searchText?: string;
};

export type TAdminUpdateGroupTutorRateVersion = {
  id: string;
  name: string;
  hideToUser: boolean;
  conditions?: Array<{
    type: TGroupTutorRateVersionConditionTypes;
    logic: TGroupTutorRateVersionTutorRegistrationDateConditionTypes;
    date: string;
  }>;
};

const apiDataProvider = new APIDataProvider();

const adminGetGroupTutorRateVersionsModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  searchText,
}: TAdminGetGroupTutorRateVersions) => {
  let path = `${AdminApiPaths.groupTutorRateVersions}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortKey) {
    path += `&sortValue=${sortValue}`;
  }

  if (searchText) {
    path += `&searchText=${searchText}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<IGroupTutorRateVersion>>
  >(path);

  return response.data;
};

export const adminCreateGroupTutorRateVersion = createAsyncThunk(
  '/admin/group-tutor-rate-versions/create',
  async (data: TAdminCreateGroupTutorRateVersion) => {
    const path = `${AdminApiPaths.groupTutorRateVersions}`;

    const response = await apiDataProvider.post<
      TApiResponse<IGroupTutorRateVersion>
    >(path, data);

    return response.data;
  }
);

export const adminDeleteGroupTutorRateVersion = createAsyncThunk(
  '/admin/group-tutor-rate-versions/delete',
  async (id: string) => {
    const path = `${AdminApiPaths.groupTutorRateVersions}/${id}`;

    const response = await apiDataProvider.delete<
      TApiResponse<IGroupTutorRateVersion>
    >(path);

    return response.data;
  }
);

export const adminUpdateGroupTutorRateVersion = createAsyncThunk(
  '/admin/group-tutor-rate-versions/update',
  async (data: TAdminUpdateGroupTutorRateVersion) => {
    const path = `${AdminApiPaths.groupTutorRateVersions}/${data.id}`;

    const response = await apiDataProvider.put<
      TApiResponse<IGroupTutorRateVersion>
    >(path, data);

    return response.data;
  }
);

export const adminVerifyGroupTutorRateVersionDelete = createAsyncThunk(
  '/admin/group-tutor-rate-versions/verify-delete',
  async (id: string) => {
    const path = `${AdminApiPaths.groupTutorRateVersions}/verify-delete/${id}`;

    const response = await apiDataProvider.get<
      TApiResponse<IGroupTutorRateVersionDeleteVerificationData>
    >(path);

    return response.data;
  }
);

export const adminGetGroupTutorRateVersions = createAsyncThunk(
  '/admin/group-tutor-rate-versions/list',
  adminGetGroupTutorRateVersionsModule
);

export const adminGetGroupTutorRateVersionsForDropdown = createAsyncThunk(
  '/admin/group-tutor-rate-versions/dropdown-list',
  adminGetGroupTutorRateVersionsModule
);
